import {  createContext, useContext, useState, useEffect,   } from "react";
import ThemeStyles from "./ThemeStyles";
import { Component } from "lucide-react";


const ThemeContext = createContext();
export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('theme') || 'light';
  });

  const [isSystemLight, setIsSystemLight] = useState(() => {
    return theme === 'system' && !window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    const applyTheme = (newTheme) => {
      if (newTheme === 'system') {
        const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        document.documentElement.setAttribute('data-theme', systemTheme);
        setIsSystemLight(!window.matchMedia('(prefers-color-scheme: dark)').matches);
      } else {
        document.documentElement.setAttribute('data-theme', newTheme);
        setIsSystemLight(newTheme === 'light');
      }
    };

    applyTheme(theme);
    localStorage.setItem('theme', theme);

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = () => {
      if (theme === 'system') {
        applyTheme('system');
      }
    };

    mediaQuery.addListener(handleChange);
    return () => mediaQuery.removeListener(handleChange);
  }, [theme]);

  const styles = ThemeStyles(theme);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, styles, isSystemLight }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeSelector = () => {
  const { theme, setTheme } = useTheme(); 
  const styles = ThemeStyles(theme);
  const {component} = styles

  const handleThemeChange = (e) => {
    setTheme(e.target.value);
  };
  

  return (
   
        <select  className='outline-none bg-transparent text-[14px] md:text-[16px]' value={theme} onChange={handleThemeChange}>
        <option style={component} value="dark">Dark</option>
        <option style={component} value="light">Light</option>
        <option style={component} value="system">System</option>
      </select>
   
  );
};